import { useId } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function TabBar({ tabs, active, hrefFor, testIdFor, testId, className }) {
  const group = useId();
  return (
    <nav className={cn("flex gap-1 overflow-x-auto border-b border-line", className)} data-testid={testId}>
      {tabs.map(([k, label]) => (
        <Link key={k} to={hrefFor(k)} data-testid={testIdFor(k)} aria-current={active === k ? "page" : undefined}
          className={cn("relative whitespace-nowrap px-3 py-2.5 text-sm transition-colors duration-150",
            active === k ? "font-medium text-brand" : "text-ink-secondary hover:text-ink")}>
          {label}
          {active === k && <motion.span layoutId={`tab-underline-${group}`} className="absolute inset-x-2 -bottom-px h-[2px] rounded-full bg-brand" transition={{ type: "spring", stiffness: 520, damping: 40 }} />}
        </Link>
      ))}
    </nav>
  );
}
